import { VueConstructor } from 'vue/types/umd';

const Constants = {
    install(Vue: VueConstructor<Vue>) {
        Vue.prototype.Constants = {
            TAX_ID_MASK: '###-##-####',
            PHONE_MASK: '###-###-####',
            DOB_MASK: '##/##/####',
            SUFFIXES: ['JR', 'SR', 'II', 'III', 'IV', 'MD', 'JD', 'PHD', 'CPA'],
            STATES: [
                        {text: 'Alaska', value: 'AK'}, 
                        {text: 'Alabama', value:'AL'},
                        {text: 'Arkansas', value:'AR'},
                        {text: 'Arizona', value:'AZ'},
                        {text: 'California', value: 'CA'},
                        {text: 'Colorado', value: 'CO'},
                        {text: 'Connecticut', value:'CT'},
                        {text: 'Delaware', value: 'DE'},
                        {text: 'Florida', value: 'FL'}, 
                        {text: 'Georgia', value: 'GA'},
                        {text: 'Hawaii', value: 'HI'},
                        {text: 'Iowa', value: 'IA'},
                        {text: 'Idaho',value: 'ID'},
                        {text: 'Illinois', value: 'IL'},
                        {text: 'Indiana', value: 'IN'},
                        {text: 'Kansas', value: 'KS'},
                        {text: 'Kentucky', value: 'KY'},
                        {text: 'Louisiana', value: 'LA'}, 
                        {text: 'Massachusetts', value: 'MA'},
                        {text: 'Maryland', value: 'MD'},
                        {text: 'Maine', value: 'ME'},
                        {text: 'Michigan', value: 'MI'},
                        {text: 'Minnesota', value: 'MN'},
                        {text: 'Missouri', value: 'MO'},
                        {text: 'Mississippi', value: 'MS'}, 
                        {text: 'Montana', value: 'MT'},
                        {text: 'North Carolina', value: 'NC'},
                        {text: 'North Dakota', value: 'ND'},
                        {text: 'Nebraska', value: 'NE'},
                        {text: 'New Hampshire', value: 'NH'},
                        {text: 'New Jersey', value: 'NJ'},
                        {text: 'New Mexico', value: 'NM'},
                        {text: 'Nevada', value: 'NV'},
                        {text: 'New York', value: 'NY'},
                        {text: 'Ohio', value: 'OH'},
                        {text: 'Oklahoma', value: 'OK'},
                        {text: 'Oregon', value: 'OR'},
                        {text: 'Pennsylvania', value: 'PA'},
                        {text: 'Rhode Island', value: 'RI'},
                        {text: 'South Carolina', value: 'SC'},
                        {text: 'South Dakota', value: 'SD'},
                        {text: 'Tennessee', value: 'TN'},
                        {text: 'Texas', value: 'TX'},
                        {text: 'Utah', value: 'UT'},
                        {text: 'Virginia', value: 'VA'},
                        {text: 'Vermont', value: 'VT'},
                        {text: 'Washington', value: 'WA'},
                        {text: 'Washington DC', value: 'DC'},
                        {text: 'Wisconsin', value: 'WI'},
                        {text: 'West Virginia', value: 'WV'},
                        {text: 'Wyoming', value: 'WY'}
                    ]
        };
    }
};

export default Constants;